import { Component, Input, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

export enum UploadedDocsStatus {
  No = 'NO',
  Partial = 'PARTIAL',
  Yes = 'YES',
}

export enum UploadedDocsStatusV2 {
  No = 'NO',
  Yes = 'YES',
}

@Component({
  selector: 'ew-mat-accordion',
  templateUrl: './mat-accordion.component.html',
  styleUrl: './mat-accordion.component.scss',
})
export class MatAccordionComponent {
  @Input() hidden: boolean = false;
  panelOpenState: boolean = false;

  @ViewChild('matAccordion')
  matAccordion!: MatExpansionPanel;

  @Input() translations: string[] = [];

  openPanel() {
    this.matAccordion.open();
  }
}
